module.exports = __webpack_public_path__ + "img/calendar-icon.ebd7798.svg";